import { homepageTabSlice } from "./homepageTabSlice";

const { actions } = homepageTabSlice;

export const setTabCategoryList = payload => dispatch => {
  return dispatch(actions.categoryList(payload));
};

export const setTabMakesList = payload => dispatch => {
  return dispatch(actions.makesList(payload));
};

export const setTabModelsList = payload => dispatch => {
  return dispatch(actions.modelsList(payload));
};
